// extracted by mini-css-extract-plugin
export var component = "TextParagraph-module--component--f8492";
export var fadePop = "TextParagraph-module--fade-pop--98830";
export var growHeightIn = "TextParagraph-module--grow-height-in--93d1f";